export default {"src":"/_next/static/media/remove.c408161b.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};